<div data-testid="gross-fare-by-external-travel-type-chart-container">
  <app-generic-chart 
    [data]="data" 
    [presentationType]="presentationType"
    [chartConfiguration]="chartConfiguration">
  </app-generic-chart>
</div>